// extracted by mini-css-extract-plugin
export default {"error":"ErrorPage_error__mIvQr","error404":"ErrorPage_error404__fogKU","error503":"ErrorPage_error503__ooelA"};